/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextremovelink3Inputs */

const en_richtextremovelink3 = /** @type {(inputs: Richtextremovelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove link`)
};

const de_richtextremovelink3 = /** @type {(inputs: Richtextremovelink3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link entfernen`)
};

/**
* | output |
* | --- |
* | "Remove link" |
*
* @param {Richtextremovelink3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextremovelink3 = /** @type {((inputs?: Richtextremovelink3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextremovelink3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextremovelink3(inputs)
	return de_richtextremovelink3(inputs)
});
export { richtextremovelink3 as "richTextRemoveLink" }